import {
  Alert,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateMemoBilanSchema } from "../schema";
import * as actions from "../redux/state/MemoBilansAction";
import * as actionsCompanies from "../../../../companies/redux/state/CompaniesAction";
import * as modalActions from "../modalActionTypes";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { getErrorMessage } from "common/utils/Helper";

export default function FormUpdateMemoBilan({
  setOpen,
  memoBilanId,
  setMemoBilanId,
  setAction,
  companyId,
  setCompanyId,
}) {
  const dispatch = useDispatch();
  const location = useLocation();

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  
  // order select companies
  const orderCompanies = {
    sort: "raison_social",
    order: "asc",
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(actions.editMemoBilan(memoBilanId));
    dispatch(actionsCompanies.getCompanies(orderCompanies));
  }, []);
  const memoBilan = useSelector((state) => state?.memoBilans?.memoBilan);
  const [value, setValue] = useState(dayjs(memoBilan?.date));

  const companies = useSelector((state) => state?.companies.companies);

  const onSubmit = (values) => {
    const request = {
      payload: values,
      successCallBack: (response) => {
        closeErrorSB()
        setCompanyId(values?.company_id ?? companyId);
        setAction(modalActions.ADD);
        setMemoBilanId("");
        setOpen(false);
        let queryParam = {};
        if (
          (companyId.toString().length > 0 && companyId !== undefined) ||
          (values?.company_id.toString().length > 0 && values?.company_id !== undefined)
        ) {
          queryParam = { companyId: values?.company_id ?? companyId, sort: "date", order: "desc" };
        }
        dispatch(actions.getMemoBilans(queryParam));
        console.log("response", response);
      },
      failCallBack: (error) => {
        console.log("error", error);
        setErrorMessage(getErrorMessage(error))
        openErrorSB();
      },
    };
    dispatch(actions.updateMemoBilan(request));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: memoBilan?.id,
      fond_roulement_net_global: memoBilan?.fond_roulement_net_global,
      actif_circulant_net: memoBilan?.actif_circulant_net,
      effectifs: memoBilan?.effectifs,
      valeur_de_lentreprise:memoBilan?.valeur_de_lentreprise, 
      date: memoBilan?.date,
      company_id: memoBilan?.company_id,
    },
    validationSchema: updateMemoBilanSchema,
    onSubmit,
  });

  const disabledSelect = location?.state?.id ? true: false;

  const { handleSubmit, errors, values, handleChange } = formik;
  return (
    <MDBox m={1}>
      {errorSB && (
        <Alert severity="error">
          {errorMessage}
        </Alert>
      )}
      <form onSubmit={handleSubmit}>
        <MDBox py={2}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="fond_roulement_net_global"
                  label="Fonds de roulememt Net global"
                  error={errors.fond_roulement_net_global ? true : false}
                  onChange={handleChange}
                  value={values.fond_roulement_net_global?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.fond_roulement_net_global ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="actif_circulant_net"
                  label="Actif circulant net"
                  error={errors.actif_circulant_net ? true : false}
                  onChange={handleChange}
                  value={values.actif_circulant_net?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.actif_circulant_net ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="effectifs"
                  label="Effectifs"
                  error={errors.effectifs ? true : false}
                  onChange={handleChange}
                  value={values.effectifs?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.effectifs ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="valeur_de_lentreprise"
                  label="Valeur de l'entreprise"
                  error={errors.valeur_de_lentreprise ? true : false}
                  onChange={handleChange}
                  value={values.valeur_de_lentreprise?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.valeur_de_lentreprise ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => <TextField {...props} />}
                    name="date"
                    value={value}
                    error={errors.date ? true : false}
                    onChange={(newValue) => {
                      setValue(newValue);
                      formik.setFieldValue("date", dayjs(newValue).format("YYYY-MM-DD"));
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="company_id">Entreprise</InputLabel>
                <Select
                  name="company_id"
                  style={{ height: "40px" }}
                  labelId="state_label"
                  label="Entreprise"
                  error={errors.company_id ? true : false}
                  onChange={handleChange}
                  value={values.company_id ?? ""}
                  disabled = {disabledSelect}
                >
                  {companies?.data?.map((company) => {
                    return (
                      <MenuItem key={company?.id} value={company?.id}>
                        {/* <b>{company?.raison_social}</b>&nbsp;({company?.country_id}) */}
                        <p>
                          <b>{company?.raison_social}</b> ({company?.country?.name})
                        </p>
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors.country_id ? (
                  <FormHelperText error>{errors?.company}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox sx={{ display: "flex" }}>
          <MDBox mr={1} sx={{ flexGrow: "1" }}>
            <MDButton onClick={handleClose} type="submit" color="primary" fullWidth>
              Annuler
            </MDButton>
          </MDBox>
          <MDBox sx={{ flexGrow: "1" }}>
            <MDButton type="submit" color="info" fullWidth>
              Modifier
            </MDButton>
          </MDBox>
        </MDBox>
      </form>
    </MDBox>
  );
}
